/* ============================================
   catch it - Main JavaScript (Shopify Theme)
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // =========================================
  // Navbar scroll effect
  // =========================================
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  // =========================================
  // Mobile menu
  // =========================================
  const menuBtn = document.getElementById('menuBtn');
  const navLinks = document.getElementById('navLinks');

  if (menuBtn && navLinks) {
    const setMenu = (open) => {
      menuBtn.classList.toggle('active', open);
      navLinks.classList.toggle('open', open);
      document.body.classList.toggle('menu-open', open);
    };

    menuBtn.addEventListener('click', () => {
      setMenu(!navLinks.classList.contains('open'));
    });

    // Close menu when clicking a link
    navLinks.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => setMenu(false));
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && navLinks.classList.contains('open')) setMenu(false);
    });
  }

  // =========================================
  // Scroll fade-in animations
  // =========================================
  const fadeElements = document.querySelectorAll('.fade-in');

  if (fadeElements.length > 0) {
    const fadeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });

    fadeElements.forEach(el => fadeObserver.observe(el));
  }

  // =========================================
  // FAQ Accordion
  // =========================================
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.parentElement;
      const isOpen = item.classList.contains('open');

      // Close all other items
      document.querySelectorAll('.faq-item.open').forEach(openItem => {
        if (openItem !== item) openItem.classList.remove('open');
      });

      // Toggle current
      item.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', !isOpen);
    });
  });

  // =========================================
  // Categories: mobile = fading carousel (10s);
  //             desktop = rotating focus card (5s)
  // =========================================
  const catGrid = document.querySelector('.categories-grid');
  if (catGrid) {
    const cards = Array.from(catGrid.querySelectorAll('.category-card'));
    const dots = Array.from(document.querySelectorAll('.categories-dots [data-cat-dot]'));
    const mq = window.matchMedia('(max-width: 900px)');

    // --- Mobile: swipeable scroll-snap carousel ---
    const CAROUSEL_MS = 6000;
    let autoTimer = null, userInteracted = false;
    function currentIndex() {
      const center = catGrid.scrollLeft + catGrid.clientWidth / 2;
      let best = 0, bestDist = Infinity;
      cards.forEach((c, n) => {
        const cc = c.offsetLeft + c.offsetWidth / 2;
        const d = Math.abs(cc - center);
        if (d < bestDist) { bestDist = d; best = n; }
      });
      return best;
    }
    function syncDots() {
      const i = currentIndex();
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    }
    function scrollToCard(n) {
      const c = cards[n];
      if (c) catGrid.scrollTo({ left: c.offsetLeft - (catGrid.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
    }
    function autoStop() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
    function autoStart() {
      autoStop();
      autoTimer = setInterval(() => {
        if (userInteracted) return;
        scrollToCard((currentIndex() + 1) % cards.length);
      }, CAROUSEL_MS);
    }

    let rafPending = false;
    catGrid.addEventListener('scroll', () => {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(() => { rafPending = false; if (mq.matches) syncDots(); });
    }, { passive: true });
    ['touchstart', 'pointerdown', 'wheel'].forEach(ev =>
      catGrid.addEventListener(ev, () => { userInteracted = true; }, { passive: true }));

    // Tapping a dot scrolls to that card
    dots.forEach((d, n) => d.addEventListener('click', () => { userInteracted = true; scrollToCard(n); }));

    // --- Desktop focus: which card is enlarged, rotating ---
    const FOCUS_MS = 5000;
    let fIdx = 0, fTimer = null;
    function focusShow(i) {
      fIdx = (i + cards.length) % cards.length;
      cards.forEach((c, n) => c.classList.toggle('is-focus', n === fIdx));
    }
    function focusStop() { if (fTimer) { clearInterval(fTimer); fTimer = null; } }
    function focusStart() { focusStop(); fTimer = setInterval(() => focusShow(fIdx + 1), FOCUS_MS); }

    // Desktop: hovering a card focuses it and pauses auto-rotation
    cards.forEach((card, n) => {
      card.addEventListener('mouseenter', () => {
        if (!mq.matches) { focusStop(); focusShow(n); }
      });
    });
    catGrid.addEventListener('mouseleave', () => {
      if (!mq.matches) focusStart();
    });

    function update() {
      if (mq.matches) {
        // Mobile: stop focus rotation, run the swipe carousel
        focusStop();
        cards.forEach(c => c.classList.remove('is-focus'));
        userInteracted = false;
        catGrid.scrollLeft = 0;
        syncDots();
        autoStart();
      } else {
        // Desktop: stop carousel, run the focus rotation
        autoStop();
        dots.forEach(d => d.classList.remove('is-active'));
        focusShow(0);
        focusStart();
      }
    }

    mq.addEventListener('change', update);
    update();
  }

  // =========================================
  // Smooth scroll for anchor links
  // =========================================
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // =========================================
  // Train Emergency Brake
  // =========================================
  const train = document.querySelector('.dep-train');
  if (train) {
    const brakeLabel = document.createElement('span');
    brakeLabel.className = 'dep-train-brake';
    brakeLabel.textContent = '\uD83D\uDED1 Notbremse!';
    train.appendChild(brakeLabel);

    train.addEventListener('click', () => {
      train.classList.toggle('stopped');
    });
  }

  // =========================================
  // SVG Route Map: 2 through-routes, HBF = tunnel
  // =========================================
  const svgEl = document.querySelector('.bento-routes');
  const flowerEl = document.querySelector('.bento-flower');
  const hbfEl = document.querySelector('.bento-hbf');
  const petalEls = document.querySelectorAll('.bento-petal');
  const NS = 'http://www.w3.org/2000/svg';

  if (svgEl && flowerEl && hbfEl && petalEls.length >= 4) {
    // 2 paths (top + bot), but 4 trains -- 2 per path, staggered
    const routeDefs = [
      { id: 'top', lpi: 0, rpi: 1, c1: '#034ea2', c2: '#6a4c93', hbfYRatio: 0.30 },
      { id: 'bot', lpi: 2, rpi: 3, c1: '#f5b301', c2: '#0f6e8c', hbfYRatio: 0.70 },
    ];

    // 4 dedicated trains with fixed line names (slower speeds)
    const trainDefs = [
      { lineName: '1',   color: '#034ea2', routeId: 'top', speed: 0.0008, startProg: 0.05,  startDir: 1  },
      { lineName: 'ICE', color: '#eb3924', routeId: 'top', speed: 0.0006, startProg: 0.85,  startDir: -1 },
      { lineName: 'U2',  color: '#6a4c93', routeId: 'bot', speed: 0.0007, startProg: 0.08,  startDir: 1  },
      { lineName: '13A', color: '#f5b301', routeId: 'bot', speed: 0.0005, startProg: 0.80,  startDir: -1 },
    ];

    const pathEls = {};
    const trainData = [];
    let svgBuilt = false;

    function getRelRect(el) {
      const fr = flowerEl.getBoundingClientRect();
      const r = el.getBoundingClientRect();
      return {
        left: r.left - fr.left, right: r.right - fr.left,
        top: r.top - fr.top, bottom: r.bottom - fr.top,
        cx: (r.left + r.right) / 2 - fr.left,
        cy: (r.top + r.bottom) / 2 - fr.top,
        w: r.width, h: r.height,
      };
    }

    function calcPathD(route) {
      const lp = getRelRect(petalEls[route.lpi]);
      const rp = getRelRect(petalEls[route.rpi]);
      const hbf = getRelRect(hbfEl);
      const pad = 16;
      const lY = lp.bottom - 22;
      const rY = rp.bottom - 22;
      const hY = hbf.top + hbf.h * route.hbfYRatio;
      const lSt = lp.left + pad;
      const lEdge = lp.right;
      const hL = hbf.left;
      const hR = hbf.right;
      const rEdge = rp.left;
      const rSt = rp.right - pad;
      const mx1 = (lEdge + hL) / 2;
      const mx2 = (hR + rEdge) / 2;
      return [
        `M ${lSt} ${lY}`,
        `L ${lEdge} ${lY}`,
        `C ${mx1} ${lY}, ${mx1} ${hY}, ${hL} ${hY}`,
        `L ${hR} ${hY}`,
        `C ${mx2} ${hY}, ${mx2} ${rY}, ${rEdge} ${rY}`,
        `L ${rSt} ${rY}`,
      ].join(' ');
    }

    function buildSVG() {
      svgEl.innerHTML = '';
      const fr = flowerEl.getBoundingClientRect();
      svgEl.setAttribute('viewBox', `0 0 ${fr.width} ${fr.height}`);

      // Defs: gradients
      const defs = document.createElementNS(NS, 'defs');
      routeDefs.forEach(r => {
        const grad = document.createElementNS(NS, 'linearGradient');
        grad.id = `grad-${r.id}`;
        const s1 = document.createElementNS(NS, 'stop');
        s1.setAttribute('offset', '0%'); s1.setAttribute('stop-color', r.c1);
        const s2 = document.createElementNS(NS, 'stop');
        s2.setAttribute('offset', '50%'); s2.setAttribute('stop-color', '#eb3924');
        const s3 = document.createElementNS(NS, 'stop');
        s3.setAttribute('offset', '100%'); s3.setAttribute('stop-color', r.c2);
        grad.appendChild(s1); grad.appendChild(s2); grad.appendChild(s3);
        defs.appendChild(grad);
      });
      svgEl.appendChild(defs);

      // Paths + station circles
      routeDefs.forEach(r => {
        const path = document.createElementNS(NS, 'path');
        path.id = `route-${r.id}`;
        path.setAttribute('d', calcPathD(r));
        path.setAttribute('fill', 'none');
        path.setAttribute('stroke', `url(#grad-${r.id})`);
        path.setAttribute('stroke-width', '6');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('opacity', '0.9');
        svgEl.appendChild(path);
        pathEls[r.id] = path;

        const len = path.getTotalLength();
        [0, len].forEach((at) => {
          const pt = path.getPointAtLength(at);
          const dot = document.createElementNS(NS, 'circle');
          dot.setAttribute('cx', pt.x); dot.setAttribute('cy', pt.y);
          dot.setAttribute('r', '9');
          dot.setAttribute('fill', '#ffffff');
          dot.setAttribute('stroke', '#1b1b1b');
          dot.setAttribute('stroke-width', '4');
          svgEl.appendChild(dot);
        });
      });

      // Delay options: label, color (green=ontime, amber=slight, red=delayed)
      const delayOpts = [
        { label: '+0', color: '#2f7d4f' },
        { label: '+0', color: '#2f7d4f' },
        { label: '+0', color: '#2f7d4f' },
        { label: '+2', color: '#f5b301' },
        { label: '+4', color: '#f5b301' },
        { label: '+8', color: '#eb3924' },
      ];

      // 4 trains
      trainData.length = 0;
      trainDefs.forEach(td => {
        const g = document.createElementNS(NS, 'g');
        const w = td.lineName.length > 2 ? 36 : 26;
        const rect = document.createElementNS(NS, 'rect');
        rect.setAttribute('x', String(-w / 2)); rect.setAttribute('y', '-8');
        rect.setAttribute('width', String(w)); rect.setAttribute('height', '16');
        rect.setAttribute('rx', '4');
        rect.setAttribute('fill', td.color);
        g.appendChild(rect);
        const label = document.createElementNS(NS, 'text');
        label.setAttribute('x', '0'); label.setAttribute('y', '4');
        label.setAttribute('text-anchor', 'middle');
        label.setAttribute('font-size', '10'); label.setAttribute('font-weight', '700');
        label.setAttribute('font-family', 'inherit');
        label.setAttribute('fill', '#fff');
        label.textContent = td.lineName;
        g.appendChild(label);

        // Delay label above the train
        const initDelay = delayOpts[Math.floor(Math.random() * delayOpts.length)];
        const delayLabel = document.createElementNS(NS, 'text');
        delayLabel.setAttribute('x', '0'); delayLabel.setAttribute('y', '-14');
        delayLabel.setAttribute('text-anchor', 'middle');
        delayLabel.setAttribute('font-size', '10'); delayLabel.setAttribute('font-weight', '700');
        delayLabel.setAttribute('font-family', 'inherit');
        delayLabel.setAttribute('fill', initDelay.color);
        delayLabel.textContent = initDelay.label;
        g.appendChild(delayLabel);

        svgEl.appendChild(g);

        trainData.push({
          g, rect, label, delayLabel, routeId: td.routeId,
          lineName: td.lineName,
          progress: td.startProg,
          direction: td.startDir,
          baseSpeed: td.speed,
          speed: td.speed,
          dwellUntil: 0,
          wasInHBF: false,
          delayOpts,
        });
      });

      svgBuilt = true;
    }

    function updatePaths() {
      const fr = flowerEl.getBoundingClientRect();
      svgEl.setAttribute('viewBox', `0 0 ${fr.width} ${fr.height}`);
      routeDefs.forEach(r => {
        if (pathEls[r.id]) pathEls[r.id].setAttribute('d', calcPathD(r));
      });
    }

    // --- HBF board: countdown derived from actual train position ---
    const boardRowMap = {};
    document.querySelectorAll('.hbf-board-row').forEach(el => {
      const ln = el.dataset.line;
      boardRowMap[ln] = {
        el,
        timeEl: el.querySelector('.hbf-board-time'),
        destEl: el.querySelector('.hbf-board-dest'),
        displayMin: Math.floor(Math.random() * 3) + 5,
        phase: 'countdown',
        lastTickTs: 0,
      };
    });

    const destPool = {
      '1':   ['Auwiesen', 'Universit\u00e4t', 'Hauptplatz'],
      'ICE': ['Wien Hbf', 'M\u00fcnchen', 'Berlin Hbf'],
      'U2':  ['Seestadt', 'Schottentor', 'Karlsplatz'],
      '13A': ['Neubaugasse', 'Alserstr.', 'Skodagasse'],
    };
    const destIndex = { '1': 0, 'ICE': 0, 'U2': 0, '13A': 0 };

    function isInHBF(ptX) {
      const hbf = getRelRect(hbfEl);
      return ptX >= hbf.left && ptX <= hbf.right;
    }

    function trainEnteredHBF(lineName) {
      const b = boardRowMap[lineName];
      if (!b || b.phase === 'arrived') return;
      b.phase = 'arrived';
      b.displayMin = 0;
      b.el.classList.add('arriving');
      if (b.timeEl) { b.timeEl.textContent = 'jetzt'; b.timeEl.style.color = '#fbbf24'; }
    }

    function trainExitedHBF(lineName) {
      const b = boardRowMap[lineName];
      if (!b) return;
      b.phase = 'countdown';
      b.displayMin = Math.floor(Math.random() * 3) + 6;
      b.lastTickTs = 0;
      b.el.classList.remove('arriving');
      const dests = destPool[lineName];
      if (dests && dests.length > 1) {
        let newIdx;
        do { newIdx = Math.floor(Math.random() * dests.length); } while (newIdx === destIndex[lineName]);
        destIndex[lineName] = newIdx;
        if (b.destEl) b.destEl.textContent = dests[newIdx];
      }
      if (b.timeEl) { b.timeEl.textContent = b.displayMin + ' min'; b.timeEl.style.color = '#4ade80'; }
    }

    function updateBoardFromPosition(t, pt, ts) {
      const b = boardRowMap[t.lineName];
      if (!b || b.phase === 'arrived') return;

      if (ts - b.lastTickTs < 1000) return;
      b.lastTickTs = ts;

      const hbf = getRelRect(hbfEl);
      const hbfCx = hbf.left + hbf.w / 2;

      const headingToward = (t.direction === 1 && pt.x < hbf.left) ||
                            (t.direction === -1 && pt.x > hbf.right);

      if (headingToward) {
        const dist = Math.abs(pt.x - hbfCx);
        const maxDist = hbf.w * 2.2;
        const posMin = Math.max(1, Math.ceil((dist / maxDist) * 8));
        if (posMin < b.displayMin) {
          b.displayMin = posMin;
        }
      } else {
        if (b.displayMin > 1) {
          b.displayMin--;
        }
      }

      if (b.timeEl) {
        b.timeEl.textContent = b.displayMin + ' min';
        b.timeEl.style.color = b.displayMin <= 2 ? '#fbbf24' : '#4ade80';
      }
    }

    // --- Train animation with easing ---
    const DWELL_MIN = 3000;
    const DWELL_MAX = 6000;
    const EASE_ZONE = 0.12;

    function easeMultiplier(progress) {
      if (progress < EASE_ZONE) {
        return 0.15 + 0.85 * (progress / EASE_ZONE);
      }
      if (progress > 1 - EASE_ZONE) {
        return 0.15 + 0.85 * ((1 - progress) / EASE_ZONE);
      }
      return 1;
    }

    function animateTrains(ts) {
      if (!svgBuilt) { requestAnimationFrame(animateTrains); return; }
      trainData.forEach(t => {
        if (t.dwellUntil && ts < t.dwellUntil) return;
        t.dwellUntil = 0;

        const path = pathEls[t.routeId];
        if (!path) return;
        const len = path.getTotalLength();
        if (len === 0) return;

        const ease = easeMultiplier(t.progress);
        t.progress += t.speed * t.direction * ease;

        if (t.progress >= 1) {
          t.progress = 1; t.direction = -1;
          t.dwellUntil = ts + DWELL_MIN + Math.random() * (DWELL_MAX - DWELL_MIN);
          t.speed = t.baseSpeed * (0.85 + Math.random() * 0.3);
          const d = t.delayOpts[Math.floor(Math.random() * t.delayOpts.length)];
          t.delayLabel.textContent = d.label;
          t.delayLabel.setAttribute('fill', d.color);
        }
        if (t.progress <= 0) {
          t.progress = 0; t.direction = 1;
          t.dwellUntil = ts + DWELL_MIN + Math.random() * (DWELL_MAX - DWELL_MIN);
          t.speed = t.baseSpeed * (0.85 + Math.random() * 0.3);
          const d = t.delayOpts[Math.floor(Math.random() * t.delayOpts.length)];
          t.delayLabel.textContent = d.label;
          t.delayLabel.setAttribute('fill', d.color);
        }

        const pt = path.getPointAtLength(t.progress * len);
        t.g.setAttribute('transform', `translate(${pt.x},${pt.y})`);

        const inHBF = isInHBF(pt.x);
        if (inHBF && !t.wasInHBF) trainEnteredHBF(t.lineName);
        if (!inHBF && t.wasInHBF) trainExitedHBF(t.lineName);
        if (!inHBF) updateBoardFromPosition(t, pt, ts);
        t.wasInHBF = inHBF;
      });
      requestAnimationFrame(animateTrains);
    }

    // Init
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        buildSVG();
        requestAnimationFrame(animateTrains);
      });
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updatePaths, 150);
    });
  }

  // =========================================
  // Cart Drawer (AJAX Cart for Shopify)
  // =========================================
  const CartDrawer = (() => {
    // --- DOM references ---
    const drawer = document.querySelector('.cart-drawer');
    const overlay = document.querySelector('.cart-drawer-overlay');
    const itemsContainer = drawer ? drawer.querySelector('.cart-drawer-items') : null;
    const subtotalPrice = drawer ? drawer.querySelector('.cart-drawer-subtotal-price') : null;
    const footer = drawer ? drawer.querySelector('.cart-drawer-footer') : null;

    // If the cart drawer markup is not present, skip setup
    if (!drawer) return null;

    // --- Money formatting ---
    function formatMoney(cents) {
      const format = (window.catchit && window.catchit.moneyFormat) || '${{amount}}';
      const amount = (cents / 100).toFixed(2);
      const amountNoDecimals = Math.floor(cents / 100).toString();
      const amountWithComma = amount.replace('.', ',');
      const amountNoDecimalsWithComma = amountNoDecimals;

      return format
        .replace('{{amount_with_comma_separator}}', amountWithComma)
        .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithComma)
        .replace('{{amount_no_decimals}}', amountNoDecimals)
        .replace('{{amount}}', amount);
    }

    // --- Open / Close ---
    function openCart() {
      drawer.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    // --- Fetch cart state ---
    async function fetchCart() {
      const res = await fetch('/cart.js', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      return res.json();
    }

    // --- Add to cart ---
    async function addToCart(formData) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Could not add to cart');
      }
      const cart = await fetchCart();
      renderCart(cart);
      openCart();
      return cart;
    }

    // --- Change quantity ---
    async function changeQuantity(key, qty) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      if (!res.ok) throw new Error('Could not update cart');
      const cart = await res.json();
      renderCart(cart);
      return cart;
    }

    // --- Render cart contents ---
    function renderCart(cart) {
      // Update badge count everywhere
      updateBadge(cart.item_count);

      // Subtotal
      if (subtotalPrice) {
        subtotalPrice.textContent = formatMoney(cart.total_price);
      }

      // Items
      if (!itemsContainer) return;

      if (cart.items.length === 0) {
        itemsContainer.innerHTML = '<p class="cart-drawer-empty">Your cart is empty.</p>';
        if (footer) footer.hidden = true;
        return;
      }

      if (footer) footer.hidden = false;

      itemsContainer.innerHTML = cart.items.map(item => {
        const img = item.image
          ? `<img class="cart-item-img" src="${item.image}" alt="${item.title}" width="80" height="80" loading="lazy">`
          : '<div class="cart-item-img cart-item-img--placeholder"></div>';

        const variantTitle = item.variant_title ? `<span class="cart-item-variant">${item.variant_title}</span>` : '';

        return `
          <div class="cart-item" data-key="${item.key}">
            ${img}
            <div class="cart-item-details">
              <div class="cart-item-title">${item.product_title}</div>
              ${variantTitle}
              <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
              <div class="cart-item-qty">
                <button class="cart-item-qty-btn" data-key="${item.key}" data-delta="-1" aria-label="Decrease quantity">&minus;</button>
                <span class="cart-item-qty-value">${item.quantity}</span>
                <button class="cart-item-qty-btn" data-key="${item.key}" data-delta="1" aria-label="Increase quantity">&plus;</button>
              </div>
            </div>
            <button class="cart-item-remove" data-key="${item.key}" aria-label="Remove item">&times;</button>
          </div>
        `;
      }).join('');
    }

    // --- Update badge count on all cart icons ---
    function updateBadge(count) {
      document.querySelectorAll('.cart-icon-count').forEach(badge => {
        badge.textContent = count;
        badge.style.display = count > 0 ? '' : 'none';
      });
    }

    // --- Event listeners ---

    // Close button
    const closeBtn = drawer.querySelector('.cart-drawer-close');
    if (closeBtn) closeBtn.addEventListener('click', closeCart);

    // Overlay click
    if (overlay) overlay.addEventListener('click', closeCart);

    // Open cart triggers
    document.querySelectorAll('.cart-icon-wrapper, [data-cart-open]').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        fetchCart().then(cart => {
          renderCart(cart);
          openCart();
        });
      });
    });

    // Quantity +/- and remove (event delegation)
    if (drawer) {
      drawer.addEventListener('click', (e) => {
        // Quantity buttons
        const qtyBtn = e.target.closest('.cart-item-qty-btn');
        if (qtyBtn) {
          const key = qtyBtn.dataset.key;
          const delta = parseInt(qtyBtn.dataset.delta, 10);
          const qtyEl = qtyBtn.closest('.cart-item-qty').querySelector('.cart-item-qty-value');
          const currentQty = parseInt(qtyEl.textContent, 10) || 0;
          const newQty = Math.max(0, currentQty + delta);
          changeQuantity(key, newQty);
          return;
        }

        // Remove button
        const removeBtn = e.target.closest('.cart-item-remove');
        if (removeBtn) {
          changeQuantity(removeBtn.dataset.key, 0);
        }
      });
    }

    // Product add-to-cart form (intercept submit)
    document.querySelectorAll('.product-add-form').forEach(form => {
      form.addEventListener('submit', (e) => {
        // If Kaching Bundles is active, let the form submit natively (action="/cart/add")
        // so Kaching adds the correct bundle items with the per-item colours. Intercepting
        // it breaks Kaching's variant handling. (Kaching then routes to the cart page.)
        if (document.querySelector('.kaching-bundles__bar-container')) {
          return; // native submit → Kaching handles the add
        }
        e.preventDefault();
        addToCart(new FormData(form));
      });
    });

    // Load cart state on init to show correct badge
    fetchCart().then(cart => updateBadge(cart.item_count)).catch(() => {});

    // Public API
    return {
      open: openCart,
      close: closeCart,
      fetch: fetchCart,
      add: addToCart,
      change: changeQuantity,
      render: renderCart,
    };
  })();

  // Expose cart drawer globally so Liquid snippets or other scripts can use it
  if (CartDrawer) {
    window.catchitCart = CartDrawer;
  }

});
